import styled from '@emotion/styled';

import Form from 'components/form/Form';
import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

const sharedCardStyles = `
	padding: 2.6rem;
	border-radius: var(--large-border-radius) !important;
`;

export const InfoLine = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: ${({ alignCenter }) => (alignCenter ? 'center' : 'flex-end')};
	padding: 1rem 0;
`;

export const SavingsCalculatorPageContainer = styled.div`
	display: flex;
	flex-direction: row;
	grid-template-columns: 37rem auto;

	gap: 2rem;
	width: 100%;

	@media ${Breakpoints.mobile} {
		flex-direction: column;
		padding: 1.5rem;
	}
`;

export const CurrentPlanInfoContainer = styled(Card)`
	${sharedCardStyles}
`;

export const CalculationContainer = styled(Card)`
	${sharedCardStyles}
	width: 100%;

	& > form {
		& > .form-item {
			padding-left: 0 !important;
			padding-right: 0 !important;
		}
	}

	@media ${Breakpoints.mobile} {
		& > form {
			padding: 0 !important;
		}
	}
`;

export const CalculationSide = styled.div`
	display: flex;
	width: 37rem;
	flex-direction: column;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const PlanComparisonContainer = styled.div`
	flex-grow: 1;
`;

export const PlanComparisonCard = styled(Card)`
	${sharedCardStyles}
`;

export const PriceSwitch = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	padding: 1.5rem 2.5rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
`;

export const BorderlessForm = styled(Form)`
	padding: 0;
	border: none;
	background: none;
`;

export const PlansWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	width: 100%;
	overflow-x: auto;
	padding-top: 1rem;
	border-radius: var(--small-border-radius);

	@media ${Breakpoints.desktop} {
		flex-wrap: wrap;
	}
`;

export const PlanCard = styled(Card)`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 3rem 2rem 2rem;

	border: ${(props) => (props.isRecommended ? '1px solid var(--blue) !important' : 'unset')};
	border-radius: var(--large-border-radius) !important;
`;

export const PlanCardPrice = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

export const CornerTag = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	background: var(--blue);
	color: var(--white);
	padding: 0.5rem 1rem;
	border-radius: 0 0 8px 0;

	body[dir='rtl'] & {
		left: unset;
		right: 0;
		border-radius: 0 0 0 8px;
		padding: 0.5rem 2rem;
	}
`;

export const CardHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin-bottom: 2rem;
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--border-color);
	margin: var(--margin-2) 0;
`;

export const GreenAlert = styled.div`
	background-color: var(--forest-10);
	color: var(--forest);
	border-radius: 8px;
	padding: 2rem 1rem 2rem 2rem;
	display: flex;
	gap: 1rem;
	align-items: center;
`;

export const DiscountBadge = styled.div`
	background-color: var(--forest-10);
	border: 1px solid var(--forest-60);
	color: var(--forest);
	padding: 0.5rem 1rem;
	border-radius: 400px;
`;

export const ImageAndBadgeWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 2rem;

	body[dir='rtl'] & {
		margin-top: 1rem;
	}
`;

export const DiscountedPriceContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`;
